<template>
  <div>
    <a-visibility hide :on="[$breakpoint.mobile]">
      <div class="education-center__list-container">
        <div :class="newsListClasses">
          <education-list-item
            v-for="(item, index) in newsList"
            :key="`${item.Topic}-${index}`"
            :article="item"
            :image="item.LogoImage"
            :video="item.LogoVideo"
            :title="item.Topic"
            :tldr="item.Tldr"
            :published-on="item.PublishedOn"
            :show-disclaimer="item.IsDisclaimerVisible"
            v-on="$listeners"
          />
        </div>

        <education-video
          v-if="isVideoIncluded"
          :video="videoSettings.Video"
          :title="videoSettings.Title"
        />
      </div>
    </a-visibility>

    <a-visibility show :on="[$breakpoint.mobile]">
      <div class="education-center__list-container">
        <div :class="newsListClasses">
          <education-list-item
            v-if="firstNewsListItem"
            :article="firstNewsListItem"
            :image="firstNewsListItem.Logo"
            :title="firstNewsListItem.Topic"
            :tldr="firstNewsListItem.Tldr"
            :published-on="firstNewsListItem.PublishedOn"
            :show-disclaimer="firstNewsListItem.IsDisclaimerVisible"
            v-on="$listeners"
          />

          <education-video
            v-if="isVideoIncluded"
            :video="videoSettings.Video"
            :title="videoSettings.Title"
          />

          <education-list-item
            v-for="(item, index) in newsListWithoutFirstItem"
            :key="`${item.Topic}-${index}`"
            :article="item"
            :image="item.Logo"
            :title="item.Topic"
            :tldr="item.Tldr"
            :published-on="item.PublishedOn"
            :show-disclaimer="item.IsDisclaimerVisible"
            v-on="$listeners"
          />
        </div>
      </div>
    </a-visibility>
  </div>
</template>

<script>
import { pathOr } from 'ramda'

import { propValidator, PROP_TYPES } from '@/utils/validators'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

export default {
  name: 'NewsList',
  components: {
    EducationListItem: hydrateWhenVisible(
      () => import('../EducationListItem'),
      {
        props: [
          'article',
          'image',
          'video',
          'title',
          'tldr',
          'published-on',
          'show-disclaimer'
        ]
      }
    ),
    EducationVideo: hydrateWhenVisible(() => import('../EducationVideo'), {
      props: ['video', 'title']
    })
  },
  props: {
    newsList: propValidator([PROP_TYPES.ARRAY]),
    videoSettings: propValidator([PROP_TYPES.OBJECT], false)
  },
  computed: {
    isVideoIncluded() {
      return !!pathOr(false, ['Video'], this.videoSettings)
    },
    firstNewsListItem() {
      return this.newsList[0]
    },
    newsListWithoutFirstItem() {
      return this.newsList.slice(1)
    },
    newsListClasses() {
      return {
        'education-center__list': true,
        'education-center__list_narrow': this.isVideoIncluded,
        'education-center__list_wide': !this.isVideoIncluded
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$list-padding: 48px;
$list-padding-percent: percentage($list-padding / $desktop-full-hd-container);
$list-padding-percent-half: calc(#{$list-padding-percent} / 2);

.education-center {
  &__list-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: -40px;

    @include mobile {
      margin-bottom: 0;
    }

    &_narrow {
      width: 50%;
      padding-right: $list-padding-percent-half;

      @include desktop-lg {
        width: 100%;
        padding-right: 0;
      }

      /deep/ .education-item {
        width: calc(50% - 20px);

        @include mobile {
          width: 100%;
        }
      }
    }

    &_wide {
      width: 100%;

      @include on-desktop-xl {
        justify-content: flex-start;
      }

      @include on-desktop-xl {
        /deep/ .education-item {
          margin-right: 40px;
        }

        /deep/ .education-item:nth-child(4n) {
          margin-right: 0;
        }
      }
    }

    @include desktop-lg {
      width: 100%;
      justify-content: space-between;
    }
  }
}
</style>
